import React, { useState } from "react";
import { get } from "lodash";
import axios from "axios";
import useRazorpay from "react-razorpay";
import Loader from "../../components/common/loader";
import { notify } from "../../components/common/utils";

const RazorpayModule = (props) => {
  const Razorpay = useRazorpay();
  const [loading, setLoading] = useState(false);
  let orderDetails = props.orderDetails;
  const orderAmount = props.orderAmount;
  const transactionFee = props.transactionFee;
  const paymentMethod = props.paymentMethod;

  const updateRazorPayId = async () => {
    let payableAmount = 0;
    payableAmount = orderAmount;
    if (transactionFee > 0) {
      payableAmount = payableAmount + transactionFee;
    }
    const razorpayAccount = "old-account";
    const token = JSON.parse(localStorage.getItem("token"));
    const options = {
      method: "post",
      url: `${process.env.REACT_APP_KIKO_API_BASE_URL_V2}/update-razorpayid-v2-new`,
      headers: {
        Authorization: `${token}`,
        desktop: true,
      },
      data: {
        ondcOrderId: get(orderDetails, "ondcOrderId", ""),
        couponId: props.couponId ? props.couponId : null,
        paymentMethod,
        transactionFee,
        paymentMode: "OldAccount",
        razorpayAccount,
      },
    };
    const result = await axios(options);
    return get(result, "data.data", {});
  };

  const handlePayment = async (e) => {
    setLoading(true);
    const orderDetails1 = await updateRazorPayId();
    const razorpayId = get(orderDetails1, "razorPayOrderId", null);
    if (razorpayId) {
      const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY;
      props.setOpenRazorpay(false);
      const options = {
        key: razorpayKey,
        currency: "INR",
        name: "Kiko Live",
        description: "Order Payment",
        image: "",
        order_id: razorpayId,
        handler: async (response) => {
          setLoading(false);
          let values = { transactionFee };
          values.razorPayTransactionId = response?.razorpay_payment_id;
          let payableAmount = orderAmount;
          if (transactionFee > 0) {
            payableAmount += transactionFee;
          }
          props.onPaymentResponse({
            paymentResponse: response,
            payableAmount,
            transactionFee,
          });
        },
        prefill: {
          name: get(orderDetails, "buyerName", ""),
          email: "",
          contact: get(orderDetails, "buyerPhoneNumber", ""),
        },
        notes: {
          address: "Razorpay Corporate Office",
        },
        theme: {
          color: "#003030",
        },
        // checkout_config_id: process.env.REACT_APP_RAZORPAY_CONFIGURATION_ID,
        config: {
          display: {
            hide:
              paymentMethod === "upi"
                ? [
                  { method: "card" },
                  { method: "wallet" },
                  { method: "netbanking" },
                  { method: "paylater" },
                  { method: "emi" },
                  { method: "cardless_emi" }
                ]
                : paymentMethod === "other"
                  ? [
                    { method: "upi" },
                    { method: "wallet" },
                    { method: "paylater" },
                    { method: "emi" },
                    { method: "cardless_emi" },]
                  : [],
          },
        },
      };
      const rzpay = new Razorpay(options);
      rzpay.open();
    }
    else {
      setLoading(false);
      notify("error", "Payment Gateway not responding, Please try again later")
    }
  };

  return (
    <div className="razorpay-card-footer">
      <button
        className="btn btn-sm w-100  razorpay-cancel-btn-kl"
        onClick={() => {
          props.setOpenRazorpay(false);
        }}
        disabled={loading}
      >
        {"Close"}
      </button>
      <button
        className="btn btn-primary btn-sm w-100 razorpay-proceed-btn-kl"
        onClick={handlePayment}
        disabled={loading}
      >
        {"Proceed To Pay"}
      </button>
      <div className="dotLoader">{loading && <Loader />}</div>
    </div>
  );
};

export default RazorpayModule;
